import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const useAlbumCount = (props, swrOptions) => {
  const genUrl = () => {
    try {
      const propsObject = typeof props === 'function' ? props() : props
      if (propsObject === null) {
        return null
      }
      return `/albums/count?${stringify({ ...propsObject, limit: 30 })}`
    } catch (err) {
      return null
    }
  }
  return useCustomSWR(genUrl, swrOptions)
}
